import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

export const decoratePageComponentWithPermission = (
  PageComponent: React.FunctionComponent<any>,
  permission: any,
): React.FC<RouteComponentProps> => {
  return (...routeProps: any) => {
    return <PageComponent permission={permission} {...routeProps[0]} />;
  };
};
